module.exports = __webpack_public_path__ + "15aacda7b47201403e2b2f58acf72067.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/home.png
// module id = 577
// module chunks = 2